import React, { useState, useEffect } from 'react';
import {
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
} from '@mui/material';
import MKTypography from "components/MKTypography";
import { LocationOn, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import Logo from "assets/images/skill2.png";

const Page = () => {
  const [topTrainerData, setTopTrainerData] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [error, setError] = useState(null);
  const trainersPerSlide = 3;

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/trainer-page-less/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          setError(data.detail);
        } else {
          setTopTrainerData(data);
          setLoading(true);
          setDataLoaded(true);
        }
      })
      .catch((error) => {
        console.error(error);
        setError("Failed to fetch trainer data.");
      });
  }, []);

  const totalSlides = Math.ceil(topTrainerData.length / trainersPerSlide);

  const handlePrevSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
  };

  const handleNextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % totalSlides);
  };

  useEffect(() => {
    if (dataLoaded) {
      const intervalId = setInterval(() => {
        handleNextSlide();
      }, 5000);
      return () => clearInterval(intervalId);
    }
  }, [dataLoaded, totalSlides]);

  const renderTrainersInSlide = () => {
    const startIndex = currentSlide * trainersPerSlide;
    const endIndex = startIndex + trainersPerSlide;
    let trainersToShow = topTrainerData.slice(startIndex, endIndex);

    if (startIndex + trainersPerSlide > topTrainerData.length) {
      const remainingImages = trainersPerSlide - trainersToShow.length;
      const additionalImages = topTrainerData.slice(0, remainingImages);
      trainersToShow = [...trainersToShow, ...additionalImages];
    }

    if (loading) {
      return trainersToShow.map((trainer, index) => (
        <div key={index} style={{ width: '100%', maxWidth: '500px', margin: '15px' }}>
          <Card style={{ height: '170px', backgroundColor: '#501d1b', color: '#FFFFFF', border: '1px solid #FFFFFF' }}>
            <CardContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', height: '170px' }}>
              <Typography variant="h5" style={{ marginTop: '5px', color: '#FFFFFF' }}>{trainer.firstName}&nbsp;{trainer.lastName}</Typography>
              <Typography>
                <span style={{ fontSize: '1rem', display: 'flex', alignItems: 'center', color: '#FFFFFF' }}>
                  <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} />
                  {trainer.skills.length > 20 ? trainer.skills.substring(0, 20) + " ..." : trainer.skills}
                </span>
              </Typography>
              <Typography>
                <span style={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', fontSize: '1rem', color: '#FFFFFF' }}>
                  <LocationOn /> {trainer.trainingMode}
                </span>
              </Typography>
              <Typography>
                <span style={{ fontSize: '1rem', display: 'flex', alignItems: 'center', color: '#FFFFFF' }}>
                  {trainer.currency}&nbsp;{trainer.avgCommercialFor8hrs}
                </span>
              </Typography>
            </CardContent>
          </Card>
        </div>
      ));
    }

    return null;
  };

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h2" color="text">
            <span style={{ color: 'black' }}>Top</span>
            {' '}
            <span style={{ color: '#2e1114' }}>Trainers</span>
          </MKTypography>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginTop: "30px", marginBottom: "30px" }}>
        <Grid item xs={1}>
          <KeyboardArrowLeft style={{ marginTop: '80px', cursor: 'pointer' }} onClick={handlePrevSlide} />
        </Grid>
        <Grid item xs={10}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            {renderTrainersInSlide()}
          </Box>
        </Grid>
        <Grid item xs={1}>
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <KeyboardArrowRight style={{ marginTop: '80px', cursor: 'pointer' }} onClick={handleNextSlide} />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Page;